// /src/api/services/communicationServices.js
import axiosInstance from "./../config/axiosConfig";

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("shelLoginToken")}`,
});

// Get all conversations (Admin)
export const getConversations = () =>
  axiosInstance.get("/communication/conversations", { headers: getAuthHeaders() });

// Get messages for a conversation (Admin)
export const getMessages = (conversationId, cursor, limit = 50) =>
  axiosInstance.get(`/communication/conversations/${conversationId}/messages`, {
    headers: getAuthHeaders(),
    params: { cursor, limit },
  });

// Admin sends a message
export const sendMessageAdmin = (conversationId, dto) =>
  axiosInstance.post(
    `/communication/conversations/${conversationId}/messages/admin`,
    dto,
    { headers: getAuthHeaders() }
  );

// Upload file (image or document) - Admin
export const uploadChatFile = (formData) =>
  axiosInstance.post("/communication/upload", formData, {
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });

// Mark messages as read (Admin)
export const markReadAdmin = (conversationId) =>
  axiosInstance.put(
    `/communication/conversations/${conversationId}/read/admin`,
    {},
    { headers: getAuthHeaders() }
  );

// Get or create conversation for a survey (Admin)
export const getSurveyConversation = (surveyId, surveyerId, surveyerName) =>
  axiosInstance.get(`/communication/survey/${surveyId}`, {
    headers: getAuthHeaders(),
    params: { surveyerId, surveyerName },
  });

// Get total admin unread count
export const getAdminUnreadTotal = () =>
  axiosInstance.get("/communication/unread/admin", { headers: getAuthHeaders() });

// Get list of contacts (surveyors and admins) to start a chat
export const getContacts = () =>
  axiosInstance.get("/communication/contacts", { headers: getAuthHeaders() });

// Start or retrieve a conversation
export const startConversation = (body) =>
  axiosInstance.post("/communication/start", body, { headers: getAuthHeaders() });

// Send presence heartbeat (Admin)
export const sendPresenceHeartbeat = (status = "ACTIVE") =>
  axiosInstance.post(
    "/communication/presence/heartbeat",
    { status },
    { headers: getAuthHeaders() }
  );

// Get live presence map
export const getPresenceMap = () =>
  axiosInstance.get("/communication/presence", { headers: getAuthHeaders() });

// Delete a conversation (Admin)
export const deleteConversationAdmin = (conversationId) =>
  axiosInstance.delete(`/communication/conversations/${conversationId}`, {
    headers: getAuthHeaders(),
  });

// Delete an individual message (Admin)
export const deleteMessageAdmin = (messageId) =>
  axiosInstance.delete(`/communication/messages/${messageId}`, {
    headers: getAuthHeaders(),
  });



